import React, { useEffect, useState } from 'react';

import { SnackbarOpen } from '#app/Action/SnackbarAction';
import { dispatch } from '#app/App';
import ButtonComponent from '#app/Component/ButtonComponent';
import TextFieldComponent from '#app/Component/TextFieldComponent';
import ApiHandler, { ApiResponse } from '#app/Handler/ApiHandler';
import { Form, initFormHandler } from '#app/Handler/FormHandler';
import LoginFormLayout from '#app/View/Authentication/Login/components/LoginFormLayout';
import CheckEmail from '#app/View/Authentication/ResetPassword/CheckEmail';

const ForgotPasswordRequest: React.FC = () => {
  const [showCheckMail, setShowCheckMail] = useState<boolean>(false);

  const [form, setForm] = useState<Form>({
    email: {
      name: 'email',
      label: 'Email',
      textHelper: 'Veuillez renseigner votre adresse email',
      type: 'text',
      options: { validation: ['required', 'email'] },
    },
  });
  const handleForm = initFormHandler(form, setForm);
  useEffect(handleForm.start, []);

  const forgotPasswordRequest = () => {
    if (handleForm.checkError() < 1) {
      ApiHandler.post<string>(
        {
          route: 'api_forgot_password_request',
          data: handleForm.getData(),
        },
        (response: ApiResponse<string>) => {
          const messageVariant = response.data ? 'success' : 'error';

          dispatch(
            SnackbarOpen({
              text: response.data ? response.data : response.error?.message || "Une erreur inattendue s'est produite.",
              variant: messageVariant,
            }),
          );
          setShowCheckMail(true);
        },
      );
    }
  };

  return (
    <LoginFormLayout>
      {showCheckMail ? (
        <CheckEmail />
      ) : (
        <>
          <h2>Réinitialiser votre mot de passe</h2>
          <small>Nous vous enverrons un lien pour réinitialiser votre mot de passe.</small>
          <TextFieldComponent id="email" handler={handleForm} />
          <ButtonComponent type="submit" label="Envoyer" onClick={forgotPasswordRequest} />
        </>
      )}
    </LoginFormLayout>
  );
};

export default ForgotPasswordRequest;
